// extracted by mini-css-extract-plugin
export default {"root":"ArticleList_root__WRN5c","collection":"ArticleList_collection__zxbqz"};